/**
 * @generated SignedSource<<5f76d1fe70120efd62a5d9df9694b167>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ConfluenceContentAccessRequestStatus {
  APPROVE = "APPROVE",
  DENY = "DENY",
  PENDING = "PENDING",
  PENDING_SITE_APPROVAL = "PENDING_SITE_APPROVAL",
}
export enum ResourceAccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}
export type useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_nodes_ConfluenceContentAccessRequest_user_AtlassianUser_emails_AtlassianUserEmail =
  {
    __typename?: "AtlassianUserEmail";
    isPrimary: boolean | null;
    value: string | null;
  };
export type useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_nodes_ConfluenceContentAccessRequest_user_AtlassianUser_photos_AtlassianUserPhoto =
  {
    __typename?: "AtlassianUserPhoto";
    isPrimary: boolean | null;
    value: string | null;
  };
export type useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_nodes_ConfluenceContentAccessRequest_user_AtlassianUser =
  {
    __typename?: "AtlassianUser";
    displayName: string | null;
    emails: Array<useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_nodes_ConfluenceContentAccessRequest_user_AtlassianUser_emails_AtlassianUserEmail | null> | null;
    photos: Array<useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_nodes_ConfluenceContentAccessRequest_user_AtlassianUser_photos_AtlassianUserPhoto | null> | null;
  };
export type useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_nodes_ConfluenceContentAccessRequest =
  {
    __typename?: "ConfluenceContentAccessRequest";
    accessRequestedAaid: string;
    requestAccessType: ResourceAccessType;
    status: ConfluenceContentAccessRequestStatus;
    id: string;
    user: useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_nodes_ConfluenceContentAccessRequest_user_AtlassianUser | null;
  };
export type useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    endCursor: string | null;
    hasNextPage: boolean | null;
    startCursor: string | null;
  };
export type useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection =
  {
    __typename?: "ConfluenceContentAccessRequestConnection";
    nodes: Array<useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_nodes_ConfluenceContentAccessRequest | null>;
    pageInfo: useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection_pageInfo_PageInfo;
  };
export type useAccessRequestsQuery_Query = {
  __typename?: "Query";
  confluence_contentAccessRequestByStatus: useAccessRequestsQuery_confluence_contentAccessRequestByStatus_ConfluenceContentAccessRequestConnection | null;
};
export type useAccessRequestsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
  cloudId: Scalars["ID"]["input"];
  contentId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<ConfluenceContentAccessRequestStatus>;
}>;
export type useAccessRequestsQuery = useAccessRequestsQuery_Query;
